import type { IdType } from 'ts/IdType';

const STORAGE_KEYS = {
  token: 'token',
  balanceCurrencyId: 'balanceCurrencyId',
};

export const getToken = () => localStorage.getItem(STORAGE_KEYS.token);

export const saveToken = (token: string) => localStorage.setItem(STORAGE_KEYS.token, token);

export const clearAuthData = () => localStorage.removeItem(STORAGE_KEYS.token);

export const getBalanceCurrencyId = () => localStorage.getItem(STORAGE_KEYS.balanceCurrencyId);

export const saveBalanceCurrencyId = (balanceCurrencyId: IdType) =>
  localStorage.setItem(STORAGE_KEYS.balanceCurrencyId, balanceCurrencyId);
